<template>
    <div>
        <div v-if="!!structures.length != 0">
            <b-row align-v="center">
                <b-col cols="12" lg="6">
                    <b-form-checkbox v-model="internal">
                        Interno
                    </b-form-checkbox>
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-select-input
                        :disabled="!internal"
                        label="Estructura"
                        :options="structures"
                        :hasError="$v.thePerson.structureId.$error"
                        errorMessage="Debe seleccionar la estructura"
                        @change="$v.thePerson.structureId.$touch()"
                        v-model="thePerson.structureId"
                        :required="true"
                    />
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-text-input
                        label="Nombre Completo"
                        id="name"
                        :required="true"
                        :hasError="$v.thePerson.name.$error"
                        errorMessage="Debe escribir el nombre"
                        @input="$v.thePerson.name.$touch()"
                        v-model="thePerson.name"
                        aria-describedby="description"
                    ></app-form-text-input>
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-text-input
                        label="Documento de la persona"
                        id="document"
                        :required="true"
                        :hasError="$v.thePerson.document.$error"
                        errorMessage="Debe escribir el documento del usuario"
                        @input="$v.thePerson.document.$touch()"
                        v-model="thePerson.document"
                    ></app-form-text-input>
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-text-input
                        label="E-mail"
                        id="email"
                        :hasError="$v.thePerson.email.$error"
                        errorMessage="Debe escribir un email valido"
                        @input="$v.thePerson.email.$touch()"
                        v-model="thePerson.email"
                    ></app-form-text-input>
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-text-input
                        label="Teléfono"
                        id="phone"
                        v-model="thePerson.phone"
                    ></app-form-text-input>
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-text-input
                        label="Posición - Cargo"
                        id="position"
                        v-model="thePerson.position"
                    ></app-form-text-input>
                </b-col>
                <b-col cols="12" lg="6">
                    <app-form-select-input
                        :options="arls"
                        v-model="thePerson.arlId"
                        label="ARL"
                    ></app-form-select-input>
                </b-col>
                <b-col cols="12">
                    <app-form-textarea-input
                        label="Notas"
                        v-model="thePerson.notes"
                    ></app-form-textarea-input>
                </b-col>
            </b-row>
        </div>
        <div v-if="!structures.length != 0" class="alert alert-danger">
            <div>No hay estructuras asociadas</div>
        </div>
    </div>
</template>
<script>
import userRepository from "../../../repositories/users.repository.js";
import { required, email, numeric, requiredIf } from "vuelidate/lib/validators";
import {
    alphaSpaces,
    alphaNumericNoSpaces
} from "../../../utils/CustomValidators";
import structuresRepository from "../../../repositories/structures.repository.js";
import peopleRepository from "../../../repositories/people.repository.js";
import { mapGetters } from "vuex";

export default {
    props: {
        myPerson: {
            default: null
        },
        myClient: {
            default: null
        },
        onSave: {
            type: Function
        }
    },

    data() {
        return {
            thePerson: {
                arlId: "",
                clientId: "",
                document: "",
                email: "",
                internal: 0,
                name: "",
                notes: "",
                phone: "",
                photo: "",
                position: '',
                structureId: "",
                userId: "",
            },
            structures: [],
            internal: false
        };
    },
    validations: {
        thePerson: {
            name: {required},
            clientId: {required},
            document: {required, numeric},
            email: {email},
            structureId: {required: requiredIf(function() {
                return !!this.thePerson.internal
            })}
        }
    },
    watch: {
        myPerson(val) {
            this.fillForm();
        },
        myClient(client) {
            this.loadStructures();
        },
        internal(val) {
            if (val) {
                this.thePerson.internal = 1;
            } else {
                this.thePerson.internal = 0;
            }
        }
    },
    computed: {
        ...mapGetters(["arls"]),
        requireStructure() {
            return !(!!this.myPerson && !this.myPerson.internal);
        }
    },
    methods: {
        loadStructures() {
            const sr = Object.assign({}, structuresRepository);
            sr.all(this.myClient.id)
                .then(data => {
                    this.structures = data;
                })
                .catch(error =>
                    toastr.error("Ocurrio un error al cargar los perfiles")
                );
        },
        registerPerson() {
            this.thePerson.clientId = this.myClient.id;
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            this.thePerson.userId = this.user.id;

            const pr = Object.assign({}, peopleRepository);
            pr.savePerson(this.thePerson)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        Object.keys(this.thePerson).map(
                            key => (this.thePerson[key] = "")
                        );
                        this.$v.$reset();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al guardar la persona");
                });
        },
        updatePerson(id) {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const pr = Object.assign({}, peopleRepository);
            pr.updatePerson(this.thePerson, this.myPerson.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        Object.keys(this.thePerson).map(
                            key => (this.thePerson[key] = "")
                        );
                        this.$v.$reset();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al actualizar la persona");
                });
        },
        saveOrUpdate() {
            if (!!this.myPerson) {
                this.updatePerson();
            } else {
                this.registerPerson();
            }
        },
        fillForm() {
            if (Object.keys(this.myPerson).length !== 0) {
                this.thePerson.clientId = this.myPerson.client_id

                this.thePerson.name = this.myPerson.name
                this.thePerson.email = this.myPerson.email
                this.thePerson.phone = this.myPerson.phone
                this.thePerson.document = this.myPerson.document
                this.thePerson.photo = this.myPerson.photo
                this.thePerson.notes = this.myPerson.notes
                this.thePerson.internal = this.myPerson.internal
                this.thePerson.position = this.myPerson.position
                this.internal = !!this.myPerson.internal ? true : false
                this.$nextTick(() => {
                    this.thePerson.structureId = this.myPerson.structure_id
                })
            } else {
                this.cleanFields()
            }
        },
        cleanFields() {
            this.internal = 0;
            Object.keys(this.thePerson).map(key => (this.thePerson[key] = ""));
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },

    created() {
        this.loadStructures();
        this.load("arls");
        this.$bus.$on("person-form.save", this.saveOrUpdate);
        this.$bus.$on("person-form.clean", this.cleanFields);
    },

    beforeDestroy() {
        this.$bus.$off("person-form.save");
    }
};
</script>
